import { ReleaseInfoModal } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";
import { buildEnterpriseReleaseInfoLabels } from "../i18n/enterpriseMessageBuilders";
import { useGetReleaseInfo } from "../queries/useGetReleaseInfo";

const releaseEnvironment =
  import.meta.env.VITE_DEPLOY_ENVIRONMENT ??
  (import.meta.env.DEV ? "local" : "");
const branchName = import.meta.env.VITE_BRANCH_NAME ?? "local";
const commitId = import.meta.env.VITE_COMMIT_ID ?? "local";
const releaseTag = import.meta.env.VITE_DEPLOYMENT_RELEASE_TAG ?? "";
const releaseRecordParameterName =
  import.meta.env.VITE_DEPLOYMENT_RECORD_PARAMETER_NAME ??
  (releaseEnvironment
    ? `/assetwatch/deployments/${releaseEnvironment}/enterprise`
    : "");

export function EnterpriseReleaseInfo({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  const labels = buildEnterpriseReleaseInfoLabels(t);
  const releaseInfoQuery = useGetReleaseInfo({
    enabled: open,
  });

  return (
    <ReleaseInfoModal
      open={open}
      onOpenChange={onOpenChange}
      appName="enterprise"
      appLabel={t("enterprise.common.enterpriseLabel")}
      labels={labels}
      modalTitle={t("enterprise.chrome.releaseInfo.modalTitle")}
      modalDescription={t("enterprise.chrome.releaseInfo.modalDescription")}
      environment={releaseEnvironment || "local"}
      branchName={branchName}
      commitId={commitId}
      releaseTag={releaseTag}
      recordParameterName={releaseRecordParameterName}
      record={releaseInfoQuery.data ?? null}
      isRecordLoading={releaseInfoQuery.isLoading}
      isRecordUnavailable={
        releaseInfoQuery.isError ||
        (!releaseInfoQuery.isLoading && !releaseInfoQuery.data)
      }
    />
  );
}
